export default "__VITE_ASSET__89437477__"